import React from 'react';

const Footer = () => {
    return (
        <div className="bg-black text-white p-5 text-center">
            <h3>Swiggy clone | 2024 | Deepa E V</h3>
        </div>
    );
};

export default Footer;
